import {useEffect, useState} from 'react';
import axios from "axios";
import moment from "moment";

function convertToDateTime(time, year, month, day) {
    const fullTime = time + ' ' + year + ':' + month + ':' + day;
    const mtime = moment(moment(fullTime, "hh:mm a YYYY:MM:DD").seconds(0).toString());
    return mtime;
};

export const useMasjidData2 = (hour, day, month, year, masjidId) => {
    const [hijri, setHijri] = useState({});
    const [salahTimes, setSalahTimes] = useState([]);
    const [otherTimes, setOtherTimes] = useState({});
    const [masjidInfo, setMasjidInfo] = useState({});

    useEffect(() => {
        if (year === 0 || month === 0) {
            console.log("ignoring as invlad date/time");
            return
        }

        console.log("invokding right ui and trying to load data")
        axios.get("https://api.masjidiapp.com/v2/masjids/4230",{headers:{apikey:"6d8d6228-0118-4f31-992c-2907b0b00174"}})
            .then((r)=>{
                console.log("-->>got data", r.data)
            window.alert("got data"+r.data)
        })
            .catch((e)=>{

                window.alert("-->>",e);
            })

        const iqamahUrl = 'https://ummahsoft.org/salahtime/api/masjidi/v1/index.php/masjids/' + masjidId + '/iqamahandprayertimes/' + year + '/' + month;

        console.log('getting data ----------------');
        axios.get(iqamahUrl).then((result) => {
            console.log(result);
            console.log("year=", year, "month=", month, "hour=", hour, "fromCache=", result.request.fromCache);
            const info = result.data.masjidInfo;
            setMasjidInfo({name: info.title, shortname: JSON.parse(info.masjid_preferences).short_name});
            const d = result.data.prayerTimes[day - 1];
            setHijri({
                month: parseInt(d.hijri_month),
                day: parseInt(d.hijri_day),
                year: 1440,
                date: d.hijri_date,
                dateChangeTime: convertToDateTime(d.magrib_start_time, year, month, day),
            });
            console.log(d.hijri_day, d.hijri_date)
            console.log("hijri", hijri);
            setSalahTimes([
                {
                    name: 'Fajr',
                    start: convertToDateTime(d.fajr_start_time, year, month, day),
                    end: convertToDateTime(d.shuruq, year, month, day),
                    iqamah: convertToDateTime(info.fajr_iqama_time, year, month, day),
                    noiqamah: false
                },
                {
                    name: 'Zuhr',
                    start: convertToDateTime(d.zuhr_start_time, year, month, day),
                    end: convertToDateTime(d.asr_start_time, year, month, day),
                    iqamah: convertToDateTime(info.zuhr_iqama_time, year, month, day),
                    noiqamah: false
                },
                {
                    name: 'Asr',
                    start: convertToDateTime(d.asr_start_time, year, month, day),
                    end: convertToDateTime(d.magrib_start_time, year, month, day),
                    iqamah: convertToDateTime(info.asr_iqama_time, year, month, day),
                    noiqamah: false
                },
                {
                    name: 'Magrib',
                    start: convertToDateTime(d.magrib_start_time, year, month, day),
                    end: convertToDateTime(d.isha_start_time, year, month, day),
                    iqamah: convertToDateTime(d.magrib_start_time, year, month, day),
                    noiqamah: false
                },
                {
                    name: 'Isha',
                    start: convertToDateTime(d.isha_start_time, year, month, day),
                    end: convertToDateTime(d.fajr_start_time, year, month, day).add(1, "day"), //fajar tomorrow
                    iqamah: convertToDateTime(info.isha_iqama_time, year, month, day),
                    noiqamah: false
                }
            ]);
            setOtherTimes(
                {
                    name: 'Shuruq',
                    start: convertToDateTime(d.shuruq, year, month, day)
                },
                {
                    name: 'Jumua',
                    start: convertToDateTime(d.zuhr_start_time, year, month, day),
                    end: convertToDateTime(d.asr_start_time, year, month, day),
                    iqamah: convertToDateTime(info.jumma1_iqama, year, month, day),
                    noiqamah: false
                }
            );
        }).catch((error) => {
            console.log(error);
        });
    }, [masjidId, hour, day, month, year]);

    return [salahTimes, otherTimes, hijri, masjidInfo];
};
